// ==============================|| OVERRIDES - BUTTON ||============================== //

import { DARK_BLUE, BUTTON_COLOR } from "../colors";

export default function Button(theme) {
    const disabledStyle = {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200]
        }
    };

    return {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                // backgroundColor: BUTTON_COLOR
            },
            styleOverrides: {
                root: {
                    fontWeight: 500
                },
                contained: {
                    ...disabledStyle
                },
                outlined: {
                    ...disabledStyle
                }
            }
        }
    };
}
